var exports = {
  "cy": "xcc377c0b--72e91f--author",
  "my": "xcc377c0b--72e91f--avatar",
  "O0": "xcc377c0b--72e91f--rating",
  "uf": "xcc377c0b--72e91f--stars",
};

module.exports = exports;
